module.exports = __webpack_public_path__ + "static/fonts/iconfont.5c12b43.eot";


//////////////////
// WEBPACK FOOTER
// ./static/iconfonts/iconfont.eot?t=1592806397367
// module id = jz5t
// module chunks = 71